import { connect } from "react-redux";
import { AppState } from "../../../store/AppState";
import OrganizationUtils from "../../../utils/organization";
import GroupsCard, {
  GroupsCardProps as _GroupsCardProps
} from "./groups-card-view";

import {
  PickReduxDispatchProps,
  PickReduxStateProps
} from "../../../util/typeUtil";
import { listOrganizationGroups } from "../../../actions";
import InProgressUtils from "../../../utils/in-progress";
import { ActionSender } from "../../../model/ActionSender";
import { addSenderArgument } from "../../../actions/actionHelpers";

export interface GroupsCardProps
  extends Omit<_GroupsCardProps, "groups" | "isReady"> {}

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<_GroupsCardProps, GroupsCardProps>;

// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _GroupsCardProps,
  GroupsCardProps
>;

const sender: ActionSender = { key: "groupsCard" };

function mapStateToProps(state: AppState): ReduxStateProps {
  return {
    groups: OrganizationUtils.selectOrganizationGroups(state),
    isReady: InProgressUtils.selectNotInProgress(sender.key, state)
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    OrganizationUtils.compareOrganizationGroupsStates(next, prev) &&
    InProgressUtils.compareInProgressStates(next, prev)
  );
}

const dispatchActions: ReduxDispatchProps = {
  onLoadGroups: addSenderArgument(sender, listOrganizationGroups)
};
export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  GroupsCardProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual
})(GroupsCard);
